import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-modal" }

import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'addHealthPro',
  emits: ["prescribeHealthPro"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emits = __emit;

function prescribeHealthPro(docGroupType: string, documentOriginalText: string) {
  emits('prescribeHealthPro', docGroupType, documentOriginalText)
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dbGroup, null, {
      default: _withCtx(() => [
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (prescribeHealthPro('MedicalSpecialty', _unref(t)('patient.document.healthPro.medicalSpecialty'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.medicalSpecialty')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (prescribeHealthPro('Nurse', _unref(t)('patient.document.healthPro.nurse'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.nurse')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (prescribeHealthPro('Physio', _unref(t)('patient.document.healthPro.physio'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.physio')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (prescribeHealthPro('Ergo', _unref(t)('patient.document.healthPro.ergo'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.ergo')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (prescribeHealthPro('Speech', _unref(t)('patient.document.healthPro.speech'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.speech')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (prescribeHealthPro('Podiatrist', _unref(t)('patient.document.healthPro.podiatrist'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.podiatrist')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (prescribeHealthPro('Pedicurist', _unref(t)('patient.document.healthPro.pedicurist'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.pedicurist')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (prescribeHealthPro('Dietitian', _unref(t)('patient.document.healthPro.dietitian'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.dietitian')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (prescribeHealthPro('Psychotherapist', _unref(t)('patient.document.healthPro.psychotherapist'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.psychotherapist')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (prescribeHealthPro('Psychologist', _unref(t)('patient.document.healthPro.psychologist'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.psychologist')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (prescribeHealthPro('Psychomotor', _unref(t)('patient.document.healthPro.psychomotor'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.psychomotor')
            }, null, 8, ["txt"])
          ]),
          _: 1
        }),
        _createVNode(_component_list_group, {
          styles: "pad-s",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (prescribeHealthPro('Midwife', _unref(t)('patient.document.healthPro.midwife'))))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.document.healthPro.midwife')
            }, null, 8, ["txt"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})